import { FC } from 'react'
import { useAppSelector } from '../../../../redux'
import { CoursePreviewContentModule } from '..'
import { StyledCoursePreviewContent } from '.'

const CoursePreviewContent: FC = () => {
  const { course } = useAppSelector((state) => state.course)

  return (
    <StyledCoursePreviewContent>
      <div className="width-controller">
        <div className="section-content">
          <h2>Course content</h2>
          <div className="course-content-container">
            {course?.modules?.map((module, index) => {
              return <CoursePreviewContentModule module={module} index={index} key={module._id} />
            })}
          </div>
        </div>
      </div>
    </StyledCoursePreviewContent>
  )
}

export default CoursePreviewContent
